export const ADD_SNACKBAR_TXT =
  'CSL Assessment/Plan requires at least a GPI-10 and/or an ICD-10 defined';
export const FORM_NAME = 'CSL_FORM';
export const QA_ID = 'csl-protocol-form-modal';
